import {
  AutocompleteMultiselection,
  YesObject
} from '@yes.technology/react-toolkit'
import { ComponentProps } from 'react'

type Option = ComponentProps<typeof AutocompleteMultiselection>['options'][0]

type MultiselectionRelationProps = {
  label: string
  statusClass: 'processing' | 'default'
  suggestions: YesObject[]
  selectedObjects: YesObject[]
  value: string
  options: Option[]
  selectedOptions: Option[]
  inputRef?: React.Ref<HTMLInputElement>
  informational?: boolean
  onChangeObjects: (objects: YesObject[]) => void
  onChangeValue: (value: string) => void
}

const MultiselectionRelation = ({
  inputRef,
  label,
  statusClass,
  options,
  selectedObjects,
  suggestions,
  value,
  selectedOptions,
  informational,
  onChangeObjects,
  onChangeValue
}: MultiselectionRelationProps) => {
  const handleSelect = (targetSelection: Option) => {
    const isOptionAlreadySelected = selectedObjects.some(
      ({ uuid }) => uuid === targetSelection.id
    )

    if (isOptionAlreadySelected) {
      onChangeObjects(
        selectedObjects.filter(({ uuid }) => uuid !== targetSelection.id)
      )
      return
    }

    const targetSuggestionObject = suggestions.find(
      ({ uuid }) => uuid === targetSelection.id
    )

    if (!targetSuggestionObject) return

    onChangeObjects([...selectedObjects, targetSuggestionObject])
  }

  return (
    <AutocompleteMultiselection
      ref={inputRef}
      statusClass={statusClass}
      onSelect={handleSelect}
      onChange={onChangeValue}
      {...{ options, value, selectedOptions, informational, label }}
    />
  )
}

export default MultiselectionRelation
